// extracted by mini-css-extract-plugin
module.exports = {"label":"label-3-96P","active":"active-1PfAp","radio":"radio-2He06"};